'use client';

import { Box, Container, Stack, Typography } from '@mui/material';
import { faqHero } from '@/containers/faq/constants/faqContent';
import { AnimateBottomToTop } from '@/components/animations/AnimateBottomToTop';
export default function FaqHero() {
  return <Box component='section' sx={{
    bgcolor: 'background.bg2',
    borderBottom: '1px solid',
    borderColor: 'line.primary'
  }} data-sentry-element="Box" data-sentry-component="FaqHero" data-sentry-source-file="FaqHero.tsx">
      <Container maxWidth='lg' sx={{
      py: {
        xs: 'var(--spacing_xl)',
        md: 'var(--spacing_xxl)'
      }
    }} data-sentry-element="Container" data-sentry-source-file="FaqHero.tsx">
        <Stack spacing='var(--spacing_m)' alignItems='center' sx={{
        maxWidth: 640,
        mx: 'auto',
        textAlign: 'center'
      }} data-sentry-element="Stack" data-sentry-source-file="FaqHero.tsx">
          <AnimateBottomToTop data-sentry-element="AnimateBottomToTop" data-sentry-source-file="FaqHero.tsx">
            <Typography component='h1' sx={{
            typography: {
              xs: 'displayStrong__Wallfund',
              md: 'landingH2Strong__Wallfund'
            },
            color: 'text.text'
          }} data-sentry-element="Typography" data-sentry-source-file="FaqHero.tsx">
              پرسش‌های{' '}
              <Box component='span' sx={{
              background: 'linear-gradient(270deg, #F1660A 0%, #FF8433 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }} data-sentry-element="Box" data-sentry-source-file="FaqHero.tsx">
                متداول
              </Box>
            </Typography>
          </AnimateBottomToTop>

          <AnimateBottomToTop delay={0.1} data-sentry-element="AnimateBottomToTop" data-sentry-source-file="FaqHero.tsx">
            <Typography component='p' sx={{
            typography: {
              xs: 'bodyMedium__Wallfund',
              md: 'bodyLargeRegular__Wallfund'
            },
            color: 'text.text2',
            lineHeight: 1.85
          }} data-sentry-element="Typography" data-sentry-source-file="FaqHero.tsx">
              {faqHero.subtitle}
            </Typography>
          </AnimateBottomToTop>
        </Stack>
      </Container>
    </Box>;
}